import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ContainerComponent} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {ReportsComponent} from "./reports.component";
import {GameService} from "../../services/game.service";

/**
 * Single scope-aware reporting page, replacing the former cross-game / game-admin pair.
 * Scope comes from route data (`isCrossGame`): global scope shows the game picker; game scope
 * reports on the active game directly. The shared ReportsComponent renders the reports.
 */
@Component({
  selector: 'app-reporting-page',
  standalone: true,
  imports: [
    ContainerComponent,
    ChooseYourGameComponent,
    ReportsComponent
  ],
  templateUrl: './reporting-page.component.html',
})
export class ReportingPageComponent {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);

  protected isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
  protected game: IGameQueryResult | null = this.isCrossGame ? null : this.gameService.activeGame();

  onGameChange(gameP: IGameQueryResult) {
    this.game = gameP;
  }
}
